/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Segment_Event_Group_TitleInputs */



/**
* | output |
* | --- |
* | "Segment Event Group" |
*
* @param {Segment_Event_Group_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const segment_event_group_title = /** @type {((inputs?: Segment_Event_Group_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Segment_Event_Group_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Segmenter le groupe d'evenements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Segment Event Group")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gruppo di eventi del segmento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Группа событий сегмента")
	if (locale === "es") return /** @type {LocalizedString} */ ("Grupo de eventos de segmento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("细分事件组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("セグメントイベントグループ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("खंड घटना समूह")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Grupo de Eventos do Segmento")
	return /** @type {LocalizedString} */ ("Segment Event Group")
});